var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InventoryPoView',{attrs:{"inventory-po-module-id":_vm.moduleIdInstallationPo}})}
var staticRenderFns = []

export { render, staticRenderFns }